"use client";

import { createContext } from "react";
import { RouterOutputs, api } from "@/lib/trpc/client";
type StateType = RouterOutputs["meRouter"]["getPreferences"]["record"];
export const PreferencesContext = createContext<{
  state: StateType | undefined;
  refresh: () => void;
}>({
  state: undefined,
  refresh: () => {}
});
export const PreferencesProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const prefQ = api.meRouter.getPreferences.useQuery(void 0, {
    retry: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false
  });
  const value = prefQ.data?.record;
  const refresh = () => prefQ.refetch();
  return <PreferencesContext.Provider value={{
    state: value,
    refresh
  }} data-sentry-element="unknown" data-sentry-component="PreferencesProvider" data-sentry-source-file="Preferences.tsx">
      {children}
    </PreferencesContext.Provider>;
};